// extracted by mini-css-extract-plugin
export default {"container":"RegularImage_container__VUwVx","moveInButtom":"RegularImage_moveInButtom__PUFSf","img":"RegularImage_img__Gy910"};